import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

const FORBIDDEN_FALLBACK = 'You do not have permission to perform this action.';

/** Parse API / permission-denied JSON bodies when HttpClient uses responseType: 'text'. */
function forbiddenMessage(err: HttpErrorResponse): string {
  const raw = err.error;
  if (raw == null || raw === '') {
    return FORBIDDEN_FALLBACK;
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (t.startsWith('{') || t.startsWith('[')) {
      try {
        const o = JSON.parse(t) as { message?: unknown };
        if (o && typeof o.message === 'string' && o.message.trim() !== '') {
          return o.message.trim();
        }
      } catch {
        /* not JSON */
      }
    }
    if (t.length > 0 && !t.startsWith('<!')) {
      return t;
    }
    return FORBIDDEN_FALLBACK;
  }
  if (typeof raw === 'object' && raw !== null && 'message' in raw) {
    const m = (raw as { message?: unknown }).message;
    if (typeof m === 'string' && m.trim() !== '') {
      return m.trim();
    }
  }
  return FORBIDDEN_FALLBACK;
}

export const errorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 403) {
        toast.error(forbiddenMessage(error), 'Permission denied');
      }
      return throwError(() => error);
    }),
  );
};
